import { SimilarMention as SimilarMentionType } from "@/types/Mention";
import { Button } from "@components/ui/button";
import { Trans } from "@lingui/react/macro";
import { ExternalLinkIcon } from "lucide-react";

type SimilarMentionProps = {
  similarMention: SimilarMentionType;
};

export default function SimilarMention({
  similarMention,
}: SimilarMentionProps) {
  return (
    <div className="flex flex-col items-start px-4 gap-0.5">
      <p className="text-sm leading-6 text-balance highlight-match">
        <strong className="font-semibold">
          {similarMention.channel_title} · {similarMention.episode_title}
        </strong>
        : <span dangerouslySetInnerHTML={{ __html: similarMention.content }} />
      </p>

      <Button
        render={
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={similarMention.mention_link}
          />
        }
        nativeButton={false}
        size="sm"
        variant="link"
        className="text-blue-500 -mx-2.5"
      >
        <Trans>Gå till källa</Trans>
        <ExternalLinkIcon />
      </Button>
    </div>
  );
}
